module.exports = __webpack_public_path__ + "img/advisory_solve3_icon_04.ca7d5aca.png";